/**
 * KpiTileDetail — side drawer opened when a supervisor clicks a KPI tile.
 * Uses ModalShell for focus trap + Escape + body-scroll lock.
 */

import type { ReactNode } from 'react';
import { ModalShell } from '@/components/primitives';

export interface KpiTileDetailProps {
  open: boolean;
  title: string;
  value: string | number;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
}

export function KpiTileDetail({ open, title, value, subtitle, onClose, children }: KpiTileDetailProps): JSX.Element | null {
  return (
    <ModalShell open={open} onClose={onClose} title={title} size="md">
      {subtitle && <p style={{ fontSize: 12, color: 'var(--ink-600)', margin: 0 }}>{subtitle}</p>}
      <div style={{ fontSize: 44, fontWeight: 800, color: 'var(--pcb-blue-dark)' }}>{value}</div>
      {children}
    </ModalShell>
  );
}
